module.exports = __webpack_public_path__ + "img/26.bed83847.png";